
import { Avatar, Card, Modal } from 'antd';
import logo from '../../Pics/logo.png'
import './Story.css'
import { useEffect, useState } from 'react';
import { createStyles, useTheme } from 'antd-style';
import { GetNoticeImage, GetUserNotices, SeenNotice } from '../../RestAPI/dbo/StoryApi';


function Story() {


    const [open, setOpen] = useState(false);

    const [notices, setNotice] = useState<Array<{}>>([]);
    const [noti, setNoti] = useState<any>({});
    const [pic, setPic] = useState("");
    async function fechUserNotices() {
        setNotice(await GetUserNotices());
    }

    async function fechPic(model: any) {
        setPic('data:image/jpeg;base64,' + await GetNoticeImage(model.Pic))

        await SeenNotice(model.ID)
    }
    useEffect(() => {
        fechUserNotices();
    }, []);

    return (
        <>
            <header className="header">
                <div className="stories-container">

                    {notices.map((n: any,index) => (

                        <div key={index} className="story" onClick={() => {
                            setOpen(true)
                            setNoti(n);
                            fechPic(n);
                        }} >
                            {/* <img src={logo} ></img> */}
                            <Avatar style={{ backgroundColor: '#001529', verticalAlign: 'middle', fontSize: 'large' }} size={'large'} >
                                {n.Titr}

                            </Avatar>
                        </div>

                    ))}
                </div>
            </header>
            <Modal

                centered
                open={open}
                footer=""
                onCancel={() => setOpen(false)}
                width={600}
                height={700}
            >

                <Card title={noti.Title}>
                    <p>{noti.Text}</p>
                    {pic ? (
                        <img src={pic} alt="Fetched from server" style={{ maxWidth: "100%" }} onClick={() => {
                            const newWindow = window.open("", "_blank");
                            if (newWindow) {
                                newWindow.document.write(
                                    `<img src="${pic}" alt="Image" style="max-width: 80%; height: auto;" />`
                                );
                            }
                        }} />
                    ) : (
                        <p>Loading...</p>
                    )}
                </Card>

            </Modal>
        </>
    );
}

export default Story;